/**
 * Design tokens cho dashboard "Commercial Position" (PnL) — theo
 * `plan/PBI_Dashboard.md` §5, RIÊNG header bảng theo template /table-style
 * (`app-table-header-cell`: gradient cream-gold + chữ teal đậm — deviation
 * khỏi navy PBI, chị Đẹp yêu cầu 2026-06-10). Total xanh nhạt, số âm đỏ.
 * Co-locate riêng cho page này (không đụng theme brand chung).
 */
export const PNL_COLORS = {
  headerBg: '#FFF9F4', // nền header bảng (cream — template /table-style)
  headerGradient: 'linear-gradient(180deg, #fff9f4 0%, #f4df9c 100%)', // gradient app-table-header-cell
  headerText: '#0B3633', // chữ header (teal đậm — var --app-table-head-text)
  totalRowBg: '#DCE6F2', // nền hàng Total (xanh nhạt)
  zebraBg: '#F5F7FA', // nền hàng xen kẽ
  rowBg: '#FFFFFF',
  negative: '#D32F2F', // số âm (đỏ)
  positive: '#1A1A1A', // số dương (đen)
  titleText: '#1F3A5F', // tiêu đề card (xanh đậm)
  subtitle: '#2563EB', // ngày dưới tiêu đề chính (xanh dương)
  warningCell: '#E53935', // ô cảnh báo (nền đỏ, chữ trắng)
  border: '#E2E8F0',
} as const
